import React, { useEffect, useState } from 'react'
import useModal from '../../../hooks/useModal'
import { Modal } from '../../atoms/modal'
import { Image } from '../../atoms/image'
import {
  GameScreenshotContainer,
  GameScreenshotDescription,
  GameScreenshotHeader,
  GameScreenshotContent,
} from './styles'
import whiteTimesIcon from '../../../images/icon_times_white.svg'

const GameScreenshotModal = ({ title }) => {
  const { openModal, closeModal, isOpen } = useModal()
  const [image, setImage] = useState()
  const [description, setDescription] = useState()

  useEffect(() => {
    const gameScreenshotElements = document.querySelectorAll(
      '.wp-game-screenshot'
    )
    gameScreenshotElements.forEach((el) =>
      el.addEventListener('click', handleScreenshotClick)
    )
    return () =>
      gameScreenshotElements.forEach((el) => {
        el.removeEventListener('click', handleScreenshotClick)
      })
  }, [])

  const handleScreenshotClick = (e) => {
    const imageDescription = e.target.getAttribute('data-game-ss-desc')
    setDescription(imageDescription)
    const screenshotSrc = e.target.getAttribute('src')
    const screenshotAlt = e.target.getAttribute('alt')
    setImage({
      url: screenshotSrc,
      alt: screenshotAlt,
    })
    openModal()
  }

  return (
    <Modal theme={'game-screenshot'} isOpen={isOpen} fade>
      <GameScreenshotContainer>
        <GameScreenshotHeader>
          <span>{title}</span>
          <img src={whiteTimesIcon} onClick={() => closeModal()} />
        </GameScreenshotHeader>
        <GameScreenshotContent>
          <Image loading="eager" {...image} />
          <GameScreenshotDescription>{description}</GameScreenshotDescription>
        </GameScreenshotContent>
      </GameScreenshotContainer>
    </Modal>
  )
}

export { GameScreenshotModal }
